import { configureStore } from "@reduxjs/toolkit";
import toggleSlice from "../features/toggle/toggleSlice";
import userSlice from "../features/user/userSlice";
import chatSlice from "../features/chat/chatSlice";
import languageReducer from '../features/languages';

export const store = configureStore({
  reducer: {
    user: userSlice,
    toggle: toggleSlice,
    chat: chatSlice,
    language: languageReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(),
});

export type RootState = ReturnType<typeof store.getState>;
